import { Stack, styled } from "@mui/material";
import { Swiper } from "swiper/react";

export const StyledCarousel = styled(Swiper)(() => ({
  ".swiper-slide": {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    width: "22rem"
  },
  width: "100%"
}));

export const StyledAnchor = styled(Stack)(({ theme }) => ({
  ":hover > a": {
    color: theme.customColors.systemSecondary01Hover
  },
  "> a": {
    color: theme.customColors.systemSecondary01,
    alignItems: "center",
    display: "flex",
    fontFamily: "Inter",
    fontSize: "0.76875rem",
    fontStyle: "normal",
    fontWeight: 500,
    gap: "0.44rem",
    justifyContent: "center",
    lineHeight: "1.09375rem",
    textAlign: "center",
    textDecoration: "none"
  }
}));

export const StyledTitleContainer = styled(Stack)(() => ({
  ":focus-visible": {
    margin: "0.2rem",
    marginTop: "1rem"
  },
  marginTop: "1rem",
  marginBottom: "1rem"
}));

interface SlideStyleProps {
  imageUrl: string;
}

export const SlideStyle = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "imageUrl"
})<SlideStyleProps>(({ imageUrl }) =>  ({
  ariaHidden: "true",
  borderRadius: "0.5rem",
  height: "6.75rem",


  backgroundImage: `url(${imageUrl})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  backgroundSize: "cover"
}));

export const BodyStyle = styled(Stack)(() => ({
  flexGrow: "1",
  gap: "1rem",
  justifyContent: "space-between"
}));
